{
  "1": "Dining",
  "2": "Boardroom",
  "3": "Cabaret",
  "5": "Theatre",
  "4": "Classroom",
  "6": "U-Shaped",
  "7": "Standing",
  "100": "Seating"
}
